import React, { useState } from 'react';
import css from './HelpAndContact.module.css';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import axios from 'axios';
import { pathByRouteName } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { apiBaseUrl } from '../../util/api';
export default function HelpAndContact() {
  const history = useHistory();
  const userState = useSelector(state => state.user);
  const { currentUser } = userState || {};
  const [loading, setLoading] = useState(false);
  return null;
  // <>
  //   <div className={css.HelpAndContactContainer}>
  //     <div className={css.QuestionText}>
  //       {' '}
  //       <FormattedMessage id="HelpAndContact.QuestionText" />
  //     </div>
  //     <div className={css.chatAndCall}>
  //       <span
  //         className={css.chatNow}
  //         onClick={async () => {
  //           //   this.setState({ loadState: chatLoading });
  //           try {
  //             setLoading(true);
  //             const { superAdminChatTxId } = currentUser?.attributes?.profile?.privateData;
  //             if (superAdminChatTxId) {
  //               const orderDetailsPath = pathByRouteName(
  //                 'OrderDetailsPage',
  //                 routeConfiguration(),
  //                 {
  //                   id: superAdminChatTxId,
  //                 }
  //               );
  //               // this.setState({ loadState: '' });
  //               setLoading(false);
  //               return history.push(orderDetailsPath);
  //             }
  //             const url = `${apiBaseUrl()}/api/user/adminProviderChat`;
  //             const { firstName, lastName } = currentUser?.attributes?.profile;
  //             const data = {
  //               providerFirstName: firstName,
  //               providerLastName: lastName,
  //               providerId: currentUser?.id?.uuid,
  //             };
  //             const order = await axios.post(url, data, { withCredentials: true });
  //             const tx = order?.data?.data?.data;
  //             //   this.setState({ loadState: '' });
  //             setLoading(false);
  //             const orderDetailsPath = pathByRouteName('OrderDetailsPage', routeConfiguration(), {
  //               id: tx.id.uuid,
  //             });
  //             history.push(orderDetailsPath);
  //           } catch (error) {
  //             setLoading(false);
  //           }
  //         }}
  //       >
  //         {loading ? (
  //           <FormattedMessage id="HelpAndContact.redirecting" />
  //         ) : (
  //           <FormattedMessage id="HelpAndContact.chatNow" />
  //         )}
  //       </span>{' '}
  //       <span className={css.orCall}>
  //         {' '}
  //         <FormattedMessage id="HelpAndContact.orCall" />
  //       </span>
  //       <span className={css.number}>
  //         {' '}
  //         <FormattedMessage id="HelpAndContact.number" />{' '}
  //       </span>
  //     </div>
  //   </div>
  // </>
}
